import React, { useEffect } from 'react';

const PLACEHOLDER_ID = 'ZN_aW577ZWwfD7ECNb';
const QUALTRICS_SRC = 'https://znaw577zwwfd7ecnb-aeromex.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_aW577ZWwfD7ECNb';

const QualtricsFeedback = () => {
  useEffect(() => {
    let script;
    let createdPlaceholder = false;

    // Ensure placeholder exists as a direct child of <body>
    let placeholder = document.getElementById(PLACEHOLDER_ID);
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.id = PLACEHOLDER_ID;
      document.body.appendChild(placeholder);
      createdPlaceholder = true;
      console.info('Qualtrics: created placeholder div on body');
    }

    // Create and append script
    script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = QUALTRICS_SRC;
    script.async = true;

    script.onload = () => console.info('Qualtrics script loaded:', QUALTRICS_SRC);
    script.onerror = (e) => console.error('Qualtrics script failed to load:', e, QUALTRICS_SRC);

    document.body && document.body.appendChild(script);

    // Inject debug CSS to ensure the intercept is visible above other UI
    const css = `#${PLACEHOLDER_ID} { position: fixed !important; bottom: 16px !important; right: 16px !important; z-index: 2147483647 !important; pointer-events: auto !important; } #${PLACEHOLDER_ID} * { z-index: 2147483647 !important; }`;
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head && document.head.appendChild(style);

    // Log placeholder contents shortly after load to help debugging
    const debugTimer = setTimeout(() => {
      const p = document.getElementById(PLACEHOLDER_ID);
      console.info('Qualtrics placeholder element:', p);
      try {
        console.info('Qualtrics placeholder innerHTML length:', p && p.innerHTML ? p.innerHTML.length : 0);
      } catch (e) {
        console.warn('Cannot read innerHTML of placeholder', e);
      }
    }, 1200);

    return () => {
      try {
        clearTimeout(debugTimer);
        if (script && script.parentNode) script.parentNode.removeChild(script);
        if (style && style.parentNode) style.parentNode.removeChild(style);
        if (createdPlaceholder) {
          const el = document.getElementById(PLACEHOLDER_ID);
          el && el.parentNode && el.parentNode.removeChild(el);
        }
      } catch (e) {
        // ignore
      }
    };
  }, []);

  return <></>;
};

export default QualtricsFeedback;
